/**
 * 选择题
 * @param tips
 * @param options
 * @param mode
 * @param _index
 */
import {BUTTONS, tipsToCard} from '../steps-runtime';
import event, {EVENTS} from '../../lib/event';
import {BATCH_TIPS_MODE, GUIDE_MODE, OPACITY_FOCUS_COVER, ZINDEX_FOCUS_COVER} from '../../lib/constant';
import {renderCover} from '../../lib/utils';
import {clearCover} from '../highlight';

export default function showOptions({tips, options}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve, reject) => {
        let card;
        if (tips) {
            card = tipsToCard(_index.actionIndex, tips);
        }else {
            card = {actionIndex: _index.actionIndex, lines: []}
        }
        for (let i = 0; i < options.length; ++i) {
            let line = {button: options[i].text, event: EVENTS.STEP_OPTION_SELECTED};
            if (options[i].correct)
                line.correct = options[i].correct;
            card.lines.push(line);
        }
        if (!window.stepsRuntime.insertCard(_index.stepIndex, card, mode === BATCH_TIPS_MODE)) {
            //如果是重复的选择题，不再重复处理
            resolve();
            return;
        }
        if (mode === BATCH_TIPS_MODE) {
            resolve();
            return;
        }else if (mode === GUIDE_MODE) {
            renderCover();
        }

        const handleSelected = ({button}) => {
            window.stepsRuntime.insertReply(_index, button);
            //更新按钮状态
            card = {...card};
            card.lines = [...card.lines];
            for (let i = 0; i < card.lines.length; ++i) {
                let line = card.lines[i] = {...card.lines[i]};
                if (line.event === EVENTS.STEP_OPTION_SELECTED) {
                    if (line.button === button) {
                        line.selected = true;
                    }
                    line.disable = true;
                }
            }
            window.stepsRuntime.replaceCard(_index.stepIndex, card);

            //执行选择后的动作
            for (let i = 0; i < options.length; ++i) {
                if (button === options[i].text) { //被选中的选项
                    let option = options[i];
                    const wrapResolve = () => {
                        event.off(EVENTS.STEP_ABORT, onAbort);
                        clearCover();
                        resolve(option);
                    }
                    if (option.correct) { //答对了
                        //TODO
                    }
                    if (option.msg) {
                        window.stepsRuntime.insertTips(_index, option.msg);
                        window.stepsRuntime.addContinueButton();
                    }
                    wrapResolve();
                    return;
                }
            }
            reject('选项值未知');
            event.off(EVENTS.STEP_ABORT, onAbort);
        }
        const onAbort = ()=>{
            event.off(EVENTS.STEP_OPTION_SELECTED, handleSelected);
            reject('Step Abort');
        }
        event.once(EVENTS.STEP_ABORT, onAbort);
        event.once(EVENTS.STEP_OPTION_SELECTED, handleSelected);
    })
}
